__webpack_require__.p = "https://axim.ihore.id/";